import React, { useState } from "react";
import ImgVerified from "../../../../components/imgVerified/ImgVerified";
import axios from "axios";
import { useAuth } from "../../../../global-components/src";
import { useMessage } from "../../../../global-components/src";
import { Link, useNavigate } from "react-router-dom";
import { errorMessage } from "../../../../utils/TextManagerTwo";
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from "../../../../global-components/src/utils/vars";
import { Frame } from "../../../../components/Post/ImgProfilePost/frame";
import { User } from "../../../../global-components/src/types";
import { t } from "i18next";

interface UserRankingProps {
    user: User;
    hideFollowUser?: boolean;
    isBtnFollowUser?: boolean;
    clasNameSearch?: string
    onClick?: any
    clasImgAccount?: string
}

const UserRanking: React.FC<UserRankingProps> = ({ user, clasNameSearch, clasImgAccount, hideFollowUser, isBtnFollowUser=false, onClick }) => {
    const [isFollowing, setIsFollowing] = useState<boolean | undefined>(user?.is_following);
    const [isFollowed, setIsFollowed] = useState<boolean | undefined>(user?.is_followed);
    const { token, user: userAuthenticated } = useAuth();
    const { setMessage } = useMessage()
    const navigate = useNavigate();

    const handleFollowUser = async () => {
        const newFollowing = !isFollowing;
        const url = PACOCA_API_URL + "/users/" + (newFollowing ? "follow" : "unfollow") + "/" + user?.id;
        setIsFollowing(newFollowing);

        try {
            await axios.post(url, null, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            })

        } catch (err: any) {
            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err)
            if(err.status != 403){
                const newisFollowing = isFollowing;
                setIsFollowing(newisFollowing);
                setMessage(messageError, type)
            } 
            console.error('Erro:', err);
        }
    }


    return (
        <div style={{ display: "flex" }}>
            <div className="num-ranking">{user.weekly_position}</div>

            <div key={user?.id} className={`${user?.active_frame?.image_path ? "row-notification-with-frame" : "" } row-notification open-notification row-user`} style={{ position: "relative" }}>

                {user?.active_frame?.image_path &&
                    <Frame onClick={() => navigate(`/@${user?.user_name}`)} path={`${BUCKET_PACOCA_URL}/${user.active_frame?.image_path}`} className={`cursor-pointer frame-ranking`}/>
                }
                <img onClick={() => navigate(`/@${user?.user_name}`)} className={`user-select-none col-1 ${clasImgAccount ? clasImgAccount : "img-account-search img-notification"}`} src={user?.img_account ? (BUCKET_PACOCA_URL + "/" + user?.img_account) : "/img/img-account.png"} onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }} />
                <div className="col" style={{ paddingLeft: "5px", paddingRight: "5px", overflow: "hidden", textOverflow: "ellipsis", position: "relative" }} onClick={onClick ? onClick : () => navigate(`/@${user?.user_name}`)}>
                    <h5 className={`${clasNameSearch ? clasNameSearch : "h5-name-search"}`} style={{ overflowWrap: "anywhere", whiteSpace: "nowrap", marginBottom: "2px" }}>
                        {!onClick ? ( 
                            <Link className="name-search" style={{ marginRight: 5 }} to={`/@${user?.user_name}`}>{user?.name}</Link>
                        ): (
                            <span className="name-search" style={{ marginRight: 5 }}>{user?.name}</span>
                        )}
                        <ImgVerified user={user} classNameProp="user-select-none img-verificado-comentario" />
                    </h5>
                    
                    <p className="username-search" style={{ whiteSpace: "nowrap", overflow: "hidden" }}>@{user?.user_name}</p>
                </div>

                <div className="col-md-3 col-lg-3 col-5" style={{ display: "flex", justifyContent: "end", alignItems: "center", textAlign: "end" }}>
                    <div className="col col-conversar col-button-account">
                        <span className={`p-ranking-points`} style={{ width: "100%", textAlign: "end", marginTop: "20!important" }}>
                            {user.weekly_points}
                        </span>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default UserRanking;